export enum IGpuPageTabs {
  Hosts = 'hosts',
  Leases = 'leases',
}
